module.exports = __webpack_public_path__ + "img/resources.70eca2a9.svg";